import React from 'react'

const stageColors: Record<string, { bg: string; color: string }> = {
  Review: { bg: '#dbeafe', color: '#1e40af' },
  PhoneScreen: { bg: '#fef3c7', color: '#92400e' },
  Interview: { bg: '#ede9fe', color: '#5b21b6' },
  Assessment: { bg: '#fce7f3', color: '#9d174d' },
  ReferenceCheck: { bg: '#d1fae5', color: '#065f46' },
  Offer: { bg: '#ffedd5', color: '#9a3412' },
  // Feature #199: Decision renamed to Outcome.
  Outcome: { bg: '#e0e7ff', color: '#3730a3' },
}

const stageLabels: Record<string, string> = {
  Review: 'Review',
  PhoneScreen: 'Phone Screen',
  Interview: 'Interview',
  Assessment: 'Assessment',
  ReferenceCheck: 'Reference Check',
  Offer: 'Offer',
  Outcome: 'Outcome',
}

interface StageBadgeProps { stage: string }

const StageBadge: React.FC<StageBadgeProps> = ({ stage }) => {
  const colors = stageColors[stage] || { bg: '#f3f4f6', color: '#6b7280' }
  return (
    <span style={{
      display: 'inline-block', padding: '4px 10px', borderRadius: '4px',
      fontSize: '12px', fontWeight: 600, backgroundColor: colors.bg, color: colors.color,
    }}>
      {stageLabels[stage] || stage}
    </span>
  )
}

export default StageBadge
